import { cloneDeep } from 'lodash-es';

const isAffiliateRule = (ruleType: string) => {
  return ruleType === 'player_affiliate_id' || ruleType === 'player_sub_affiliate_id';
};

const normalizeRuleValues = (values: any, ruleType: string) => {
  if (!isAffiliateRule(ruleType) || !Array.isArray(values)) {
    return values;
  }

  return values.map((item) => {
    if (item && typeof item === 'object' && 'id' in item && item.id !== undefined) {
      return item.id;
    }

    return item;
  });
};

export const useSegmentRules = () => {
  const clearRules = (rules: any[] = []) => {
    return rules
      .filter((item) => item.values !== '' && (!Array.isArray(item.values) || item.values.length !== 0))
      .map((item) => ({
        ...item,
        values: normalizeRuleValues(item.values, item.rule_type),
      }));
  };

  const clearSegment = (value: any) => {
    if (value.type !== 'manual') {
      const segmentCopy = cloneDeep(value);
      const rulesGroup = segmentCopy?.rules_group?.rules || [];
      if (!segmentCopy.rules_group) {
        segmentCopy.rules_group = { rules: [] };
      }
      segmentCopy.rules_group.rules = rulesGroup.filter((group: any) => {
        group.rules = clearRules(group.rules);
        return group.rules.length !== 0;
      });
      return segmentCopy;
    }

    return value;
  };

  return {
    clearRules,
    clearSegment,
  };
};
